<ng-content></ng-content>

<div class="tr"
     [ngClass]="{
       'selected': isSelected,
       'locked': isLocked,
       'group-row': !!job?.groupedByType,
       'out-of-draft': !!job?.excluded
     }">
  <!-- Merged Sticky Column: Drag Handle + Checkbox + ID -->
  <div class="td col-id sticky-col">
    <ng-content select="[drag-handle]"></ng-content>

    <bringoz-button *ngIf="job.groupedByType" class="layout-row gap-2 pointer"
                    size="fit"
                    type="tertiary"
                    (onClick)="toggleExpand($event)">
      <bringoz-icon [iconName]="isGroupExpanded ? 'arrow-up' : 'arrow-down'" classSize="xl"></bringoz-icon>
    </bringoz-button>

    <app-planning-draft-job-action-menu *ngIf="!job.groupedByType"
                                        [job]="job"
                                        (onOpen)="onContextMenu.emit({event: $event, job: job})">
    </app-planning-draft-job-action-menu>

    <app-bringoz-checkbox *ngIf="!job.groupedByType && !isLocked"
                          style="flex-shrink: 0; display: flex;"
                          [isChecked]="isSelected"
                          (clickEvent)="onToggleSelectedJob.emit({jobIds: [job.id], isSelected: !isSelected})">
    </app-bringoz-checkbox>

    <!--Indexes In Route-->
    <div *ngIf="job.routed && routeIndexes?.length" class="index-in-route-container" [style.border-color]="routeColor">
      <div *ngFor="let indexInRoute of routeIndexes;"
           [ngClass]="{'highlighted': indexInRoute.isHighlighted}"
           [style.background]="indexInRoute.isHighlighted ? routeColor : (routeColor + 20)"
           [style.color]="indexInRoute.isHighlighted ? 'white' : routeColor"
           [style.border-color]="routeColor"
           [ngbTooltip]="'Activity Index: ' + indexInRoute.index"
           placement="right"
           container="body"
           openDelay="300">
        {{ indexInRoute.index }}
      </div>
    </div>

    <div *ngIf="settings?.columns?.id" class="flex layout-row layout-align-start-center text-ellipsis" style="min-width: 0; line-height: 1.2; gap: 5px;">
      <ng-container *ngIf="!job.groupedByType">
        <bringoz-icon *ngIf="isLocked || job.lockedRouteId"
                      iconName="lock"
                      classSize="md"
                      fill="#484848"
                      [ngbTooltip]="'Job is Locked' | translate"
                      openDelay="300">
        </bringoz-icon>

        <app-bringoz-state-link *ngIf="job.orderId"
                                class="text-ellipsis"
                                [state]="'order.info'"
                                [params]="{id : job.orderId}"
                                [permission]="'oms.orders.get'"
                                [text]="job.externalId || job.orderId"
                                [ngbTooltip]="job.externalId || job.orderId"
                                openDelay="300"
                                container="body">
        </app-bringoz-state-link>
        <span *ngIf="!job.orderId" class="br-body-1 text-ellipsis">{{ job.fulfillmentId || '---' }}</span>

        <app-bringoz-status-tag *ngIf="job.isAbortedService"
                                status="Aborted"
                                [isSmall]="true">
        </app-bringoz-status-tag>

        <bringoz-button type="tertiary"
                        size="fit"
                        style="margin-left: auto;"
                        [ngbTooltip]="'View Job Details' | translate"
                        openDelay="300"
                        (onClick)="onViewJob.emit({jobs: [job], event: $event})">
          <bringoz-icon iconName="info-outline" classSize="md" fill="#484848"></bringoz-icon>
        </bringoz-button>

        <bringoz-icon *ngIf="job.lastSyncedFromStepAt"
                      iconName="synced"
                      classSize="md"
                      [ngbTooltip]="('Synced' | translate) + ': ' + (job | bringozFullDate: 'lastSyncedFromStepAt') + ' ' + (job | bringozTime: 'lastSyncedFromStepAt')"
                      openDelay="300">
        </bringoz-icon>

        <div *ngIf="!!draft"
             class="pointer flex-shrink-0"
             (click)="onToggleObligateTimeWindow.emit({jobIds: [job.id], obligateTimeWindow: !isObligatedTimeWindow})">
          <bringoz-icon *ngIf="isObligatedTimeWindow"
                        iconName="toggle-on"
                        [ngbTooltip]="'Guarantee' | translate"
                        openDelay="300"></bringoz-icon>
          <bringoz-icon *ngIf="!isObligatedTimeWindow"
                        iconName="toggle-off"
                        class="show-on-hover-only"
                        [ngbTooltip]="'Set Guarantee' | translate"
                        openDelay="300"></bringoz-icon>
        </div>

        <div *ngIf="job && job.splitSuggestionType" class="split-suggestions layout-row gap-5 pointer flex-shrink-0"
             [ngbTooltip]="(job.splitSuggestionType === SplitSuggestionType.SPLIT_PACKAGES ? 'JobSplit.ByPackagesTooltip' : 'JobSplit.ByLocationTooltip') | translate"
             [class.lockSplit]="isLocked"
             placement="top"
             container="body"
             (click)="onReverseJobSplit.emit({event: $event, job: job}); $event.stopPropagation();">
          <bringoz-icon iconName="{{job.splitSuggestionType === SplitSuggestionType.SPLIT_PACKAGES ? 'BOX' : 'location-pin-outline'}}" classSize="md" fill="#484848"></bringoz-icon>
          <bringoz-icon iconName="route-split" classSize="md" fill="#484848"></bringoz-icon>
        </div>
      </ng-container>
      <ng-container *ngIf="!!job.groupedByType">
        <app-bringoz-checkbox
                              style="flex-shrink: 0; display: flex;"
                              [isChecked]="isSelected"
                              (clickEvent)="onToggleSelectedJob.emit({jobIds: job.jobIds, isSelected: !isSelected})">
        </app-bringoz-checkbox>
        <span class="br-body-1 font-weight-600 text-ellipsis" [title]="job.jobIds.length === 1 ? ('X_SERVICE' | translate: {sum: job.jobIds.length}) : ('X_SERVICES' | translate: {sum: job.jobIds.length})">
          {{ job.jobIds.length === 1 ? ('X_SERVICE' | translate: {sum: job.jobIds.length}) : ('X_SERVICES' | translate: {sum: job.jobIds.length}) }}
        </span>
      </ng-container>
    </div>
  </div>

  <ng-container *ngIf="!jobsGroupByType">
    <!-- Scrollable Columns in Body -->
    <ng-container *ngIf="settings?.columns?.address">
      <div class="td col-address col-pickup-address">
      <span class="text-ellipsis" style="width: 100%;">
        <ng-container *ngIf="!job.groupedByType">
          <div *ngIf="job.stops[0]" class="layout-row layout-align-start-center text-ellipsis gap-5" style="width: 100%;">
            <app-task-purpose [purpose]="job.stops[0].stopType" firstLetterOnly="true"></app-task-purpose>
            <div class="flex td small layout-row layout-align-start-center" style="min-width: 0;"
                 (mouseenter)="onToggleIsShowAddressIconPickup(true)"
                 (mouseleave)="onToggleIsShowAddressIconPickup(false)">
              <div *ngIf="!job.stops[0].depotSyncId" class="flex layout-row layout-align-start-center" style="min-width: 0;">
                <span [appBringozTooltip]="pickupTooltip" [applyHoverColor]="true" ngbTooltip class="br-body-1 text-ellipsis" style="min-width: 0;">
                  {{ job.stops[0].address | bringozAddress }}
                </span>
                <app-address-quality
                  *ngIf="isValidAddressType(job.stops[0].address) && (isShowAddressIconPickup || !isHighQualityAddress(job.stops[0].address))"
                  [address]="job.stops[0].address.addressResolvingInfo" [query]="query"
                  [type]="type">
                </app-address-quality>
              </div>
              <span *ngIf="job.stops[0].depotSyncId" class="br-body-1 text-ellipsis" style="min-width: 0;">
                {{ job.stops[0].address | bringozAddress }}
              </span>
              <ng-template #pickupTooltip>
                <div class="layout-column layout-align-start-center">
                  <div class="layout-column layout-align-start-center">
                    <span class="br-body-2">{{ 'Address' | translate }}: {{ job.stops[0].address | bringozAddress }}</span>
                    <div class="layout-column layout-align-start-center">
                      <span class="br-body-2 margin-right-10">{{ 'Floor' | translate }}: {{ job.stops[0].address.floor || '--' }}</span>
                      <span class="br-body-2">{{ 'Apt' | translate }}: {{ job.stops[0].address.apartment || '--' }}</span>
                    </div>
                  </div>
                </div>
              </ng-template>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="!!job.groupedByType && job.groupedByType === 'pickupLocation'">
           {{ job.address | bringozAddress }}
        </ng-container>
      </span>
      </div>
      <div class="td col-address col-dropoff-address">
      <span class="text-ellipsis" style="width: 100%;">
        <ng-container *ngIf="!job.groupedByType">
          <div *ngIf="job.stops[1]" class="layout-row layout-align-start-center text-ellipsis gap-5" style="width: 100%;">
            <app-task-purpose [purpose]="job.stops[1].stopType" firstLetterOnly="true"></app-task-purpose>
            <div class="flex td small layout-row layout-align-start-center" style="min-width: 0;"
                 (mouseenter)="onToggleIsShowAddressIconDropoff(true)"
                 (mouseleave)="onToggleIsShowAddressIconDropoff(false)">
              <div *ngIf="!job.stops[1].depotSyncId" class="flex layout-row layout-align-start-center" style="min-width: 0;">
                <span [appBringozTooltip]="dropoffTooltip" [applyHoverColor]="true" ngbTooltip class="br-body-1 text-ellipsis" style="min-width: 0;">
                  {{ job.stops[1].address | bringozAddress }}
                </span>
                <app-address-quality
                  *ngIf="isValidAddressType(job.stops[1].address) && (isShowAddressIconDropoff || !isHighQualityAddress(job.stops[1].address))"
                  [address]="job.stops[1].address.addressResolvingInfo" [query]="query"
                  [type]="type">
                </app-address-quality>
              </div>
              <span *ngIf="job.stops[1].depotSyncId" class="br-body-1 text-ellipsis" style="min-width: 0;">
                {{ job.stops[1].address | bringozAddress }}
              </span>
              <ng-template #dropoffTooltip>
                <div class="layout-column layout-align-start-center">
                  <div class="layout-column layout-align-start-center">
                    <span class="br-body-2">{{ 'Address' | translate }}: {{ job.stops[1].address | bringozAddress }}</span>
                    <div class="layout-column layout-align-start-center">
                      <span class="br-body-2 margin-right-10">{{ 'Floor' | translate }}: {{ job.stops[1].address.floor || '--' }}</span>
                      <span class="br-body-2">{{ 'Apt' | translate }}: {{ job.stops[1].address.apartment || '--' }}</span>
                    </div>
                  </div>
                </div>
              </ng-template>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="!!job.groupedByType && job.groupedByType === 'dropoffLocation'">
           {{ job.address | bringozAddress }}
        </ng-container>
      </span>
      </div>
    </ng-container>

    <div *ngIf="settings?.columns?.timeWindow" class="td col-time-window">
      <div *ngIf="!job.groupedByType" class="layout-column gap-5">
        <div *ngFor="let stop of job.stops" class="layout-row layout-align-start-center gap-5 text-ellipsis">
          <bringoz-icon iconName="time-window-outline"
                        classSize="md"
                        [fill]="stop.stopType === 'Pickup' ? '#FF9936' : (stop.stopType === 'Dropoff' ? '#2196F3': '#2EBDA4')"
                        openDelay="300">
          </bringoz-icon>
          <span class="br-body-1 text-ellipsis">{{ stop | timeWindow }}</span>
        </div>
      </div>
      <span *ngIf="!!job.groupedByType" class="text-ellipsis">{{ job | planningActivityTimeWindow }}</span>
    </div>

    <div *ngIf="settings?.columns?.contacts" class="td col-contact">
      <div *ngIf="!job.groupedByType" class="layout-column gap-5">
        <div *ngFor="let stop of job.stops" class="layout-row layout-align-start-center gap-5 text-ellipsis">
          <bringoz-icon iconName="contact-circle"
                        classSize="md"
                        [fill]="stop.stopType === 'Pickup' ? '#FF9936' : (stop.stopType === 'Dropoff' ? '#2196F3': '#2EBDA4')"
                        openDelay="300">
          </bringoz-icon>
          <span class="br-body-1 text-ellipsis">{{ stop.contact?.name || '---' }}</span>
        </div>
      </div>
      <span *ngIf="!!job.groupedByType">---</span>
    </div>

    <div *ngIf="settings?.columns?.serviceTime" class="td col-service-time">
      <div *ngIf="!job.groupedByType" class="layout-column gap-5">
        <div *ngFor="let stop of job.stops" class="layout-row layout-align-start-center gap-5 text-ellipsis">
          <bringoz-icon iconName="timer-outline"
                        classSize="md"
                        [fill]="stop.stopType === 'Pickup' ? '#FF9936' : (stop.stopType === 'Dropoff' ? '#2196F3': '#2EBDA4')"
                        openDelay="300">
          </bringoz-icon>
          <span *ngIf="!stop.detailedServiceTime" class="br-body-1 text-ellipsis">
          {{ stop.serviceTimeMillis | bringozTimeConvert:true }}
        </span>
          <app-task-detailed-service-time *ngIf="!!stop.detailedServiceTime"
                                          [fontSize]="'br-body-1'"
                                          [isAllowEdit]="false"
                                          [detailedServiceTime]="stop.detailedServiceTime">
          </app-task-detailed-service-time>
        </div>
      </div>
      <span *ngIf="!!job.groupedByType">---</span>
    </div>

    <div *ngIf="settings?.columns?.sla && !job.groupedByType" class="td col-sla">
     <span class="layout-row layout-align-start-center gap-5 text-ellipsis">
       <span class="br-body-1 font-weight-600">SLA</span>
       <span class="br-body-1">{{ job | bringozDate: 'sla' }}</span>
       <span class="br-body-1">{{ job | bringozTime: 'sla' }}</span>
     </span>
    </div>
  </ng-container>

  <div *ngIf="settings?.columns?.account" class="td col-account">
     <span class="layout-row layout-align-start-center gap-5 text-ellipsis" style="width: 100%;">
       <bringoz-icon iconName="account" classSize="md" fill="#484848" openDelay="300"></bringoz-icon>
       <app-demand-account-link class="flex text-ellipsis" [account]="{name: job.accountName, id: job.accountId}" isAllowCopyButton="true"></app-demand-account-link>
     </span>
  </div>

  <ng-container *ngIf="!jobsGroupByType">
    <div *ngIf="settings?.columns?.vehicles" class="td col-vehicles">
     <span *ngIf="!job.groupedByType" class="layout-row layout-align-start-center gap-5">
       <bringoz-icon iconName="privatecar" classSize="md" fill="#484848" openDelay="300"></bringoz-icon>
       <app-bringoz-items-list-display [itemsList]="{list: job.allowedVehicleReferences, displayKey: 'name'}" maxItems="1"></app-bringoz-items-list-display>
     </span>
      <span *ngIf="!!job.groupedByType">---</span>
    </div>

    <div *ngIf="settings?.columns?.accountExternalId" class="td col-account-ext-id">
     <span *ngIf="!job.groupedByType" class="layout-row layout-align-start-center gap-5 text-ellipsis">
       <bringoz-icon iconName="account" classSize="md" fill="#484848" openDelay="300"></bringoz-icon>
       <span class="br-body-1 text-ellipsis">{{ job.accountExternalId || '---' }}</span>
     </span>
      <span *ngIf="!!job.groupedByType">---</span>
    </div>

    <div *ngIf="settings?.columns?.labels" class="td col-labels">
     <span class="layout-row layout-align-start-center gap-5">
       <bringoz-icon iconName="label-outline" classSize="md" fill="#484848" openDelay="300"></bringoz-icon>
       <app-bringoz-labels-display *ngIf="job.labels?.length" [labels]="job.labels" maxItems="1"></app-bringoz-labels-display>
       <span *ngIf="!job.labels?.length" class="br-body-1 text-ellipsis">---</span>
     </span>
    </div>

    <div *ngIf="settings?.columns?.tags" class="td col-tags">
     <span class="layout-row layout-align-start-center gap-5">
       <bringoz-icon iconName="tag-outline" classSize="md" fill="#484848" openDelay="300"></bringoz-icon>
       <app-bringoz-tags *ngIf="job.tags?.length" [tags]="job.tags" [maxTags]="1"></app-bringoz-tags>
       <span *ngIf="!job.tags?.length" class="br-body-1 text-ellipsis">---</span>
     </span>
    </div>
  </ng-container>

  <div *ngIf="settings?.columns?.skills" class="td col-skills">
     <span class="layout-row layout-align-start-center gap-5">
       <bringoz-icon iconName="skill-outline" classSize="md" fill="#484848" openDelay="300"></bringoz-icon>
       <app-skill-tags *ngIf="job.skills?.length" [skillsIds]="job.skills" limit="1"></app-skill-tags>
       <span *ngIf="!job.skills?.length" class="br-body-1 text-ellipsis">---</span>
     </span>
  </div>

  <ng-container *ngIf="!jobsGroupByType">
    <div *ngIf="settings?.columns?.packages" class="td col-packages">
     <span class="layout-row layout-align-start-center gap-5" style="width: 100%;">
       <bringoz-icon iconName="package-outline" classSize="md" fill="#484848" openDelay="300"></bringoz-icon>
       <app-bringoz-packages-items-display-list class="flex" [items]="job.packages"></app-bringoz-packages-items-display-list>
     </span>
    </div>

    <div *ngIf="settings?.columns?.leftoverReason" class="td col-leftover-reason">
    <span *ngIf="!job.groupedByType && draft?.jobIdToUnassignedJobData && draft.jobIdToUnassignedJobData[job.id]" class="layout-row layout-align-start-center gap-5">
      <bringoz-icon iconName="info-outline" classSize="md" fill="#484848" openDelay="300"></bringoz-icon>
      <ng-template #htmlContent>
        <div class="layout-column layout-align-center-start" style="width: 284px;">
          <div class="layout-row layout-align-start-center" style="width: 100%;"
               *ngFor="let c of draft.jobIdToUnassignedJobData[job.id].failedConstraints">
            <span class="br-body-2 flex-15" style="font-weight: 600 !important;">
              {{ (c.frequencyPercentage * 100).toFixed(0) }}%
            </span>
            <span class="br-body-2 flex" style="text-align: start;">
              {{ 'PLANNING_DRAFT_LEFTOVERS_REASONS.' + c.constraint.name + '.name' | translate }}
            </span>
          </div>
        </div>
      </ng-template>
      <span class="br-body-1 text-ellipsis cursor-help" [ngbTooltip]="htmlContent" openDelay="300" triggers="hover">
        {{ 'PLANNING_DRAFT_LEFTOVERS_REASONS.' + draft.jobIdToUnassignedJobData[job.id].mostLikelyReason + '.name' | translate }}
      </span>
    </span>
      <span *ngIf="job.groupedByType || !draft?.jobIdToUnassignedJobData || !draft.jobIdToUnassignedJobData[job.id]">---</span>
    </div>

    <div *ngIf="settings?.columns?.recurringServiceTemplateId" class="td col-recurring">
    <span *ngIf="!job.groupedByType && !!job.serviceTemplateId" class="layout-row layout-align-start-center gap-5">
      <bringoz-icon iconName="recurring" class="gray-102" classSize="md" openDelay="300"></bringoz-icon>
      <app-bringoz-state-link class="text-ellipsis"
                              [state]="'recurring-services'"
                              [permission]="'recurring-service-template.list'"
                              [params]="{queryString: job.serviceTemplateId}"
                              [text]="job.serviceTemplateId">
      </app-bringoz-state-link>
    </span>
      <span *ngIf="job.groupedByType || !job.serviceTemplateId">---</span>
    </div>

    <div *ngIf="settings?.load?.weight" class="td col-load col-load-weight">
    <span class="layout-row layout-align-start-center gap-5">
      <bringoz-icon iconName="weight" classSize="md" fill="#484848" openDelay="300"></bringoz-icon>
      <span class="br-body-1 text-ellipsis">{{ job.packages | planningPackagesWeightPipe:true:true }}</span>
    </span>
    </div>
    <div *ngIf="settings?.load?.volume" class="td col-load col-load-volume">
    <span class="layout-row layout-align-start-center gap-5">
      <bringoz-icon iconName="volume" classSize="md" fill="#484848" openDelay="300"></bringoz-icon>
      <span class="br-body-1 text-ellipsis">{{ job.packages | planningPackagesVolumePipe:true }}</span>
    </span>
    </div>
    <div *ngIf="settings?.load?.packages" class="td col-load col-load-packages">
    <span class="layout-row layout-align-start-center gap-5">
      <bringoz-icon iconName="package-outline" classSize="md" fill="#484848" [ngbTooltip]="'Packages' | translate" openDelay="300"></bringoz-icon>
      <span class="br-body-1 text-ellipsis">{{ job.packages | planningPackagesPipe:false }}</span>
    </span>
    </div>
    <div *ngIf="settings?.load?.value" class="td col-load col-load-value">
    <span class="layout-row layout-align-start-center gap-5">
      <bringoz-icon iconName="dollar-circle" classSize="md" fill="#484848" openDelay="300"></bringoz-icon>
      <span class="br-body-1 text-ellipsis">{{ job.price | bringozPrice }}</span>
    </span>
    </div>
    <div *ngIf="settings?.load?.pallets" class="td col-load col-load-pallets">
    <span class="layout-row layout-align-start-center gap-5">
      <bringoz-icon iconName="pallets" classSize="md" fill="#484848" [ngbTooltip]="'Pallets' | translate" openDelay="300"></bringoz-icon>
      <span class="br-body-1 text-ellipsis">{{ job.packages | planningPackagesPalletsPipe: false }}</span>
    </span>
    </div>
    <div *ngIf="settings?.load?.spots" class="td col-load col-load-spots">
    <span class="layout-row layout-align-start-center gap-5">
      <bringoz-icon iconName="spot" classSize="md" fill="#484848" openDelay="300"></bringoz-icon>
      <span class="br-body-1 text-ellipsis">{{ job.packages | planningPackagesSpotsPipe }}</span>
    </span>
    </div>
  </ng-container>
</div>

<div *ngIf="isGroupExpanded && job.groupedByType" class="child-rows-container">
  <app-planning-draft-jobs-table-list-row
       *ngFor="let jobFromGroup of job.jobs; trackBy: trackByJobId"
       [job]="jobFromGroup"
       [draft]="draft"
       [settings]="settings"
       [isChild]="true"
       [isSelected]="false"
       [routeIndexes]="[]"
       [routeColor]="''"
       [isObligatedTimeWindow]="false"
       [query]="query"
       [type]="type"
       (onViewJob)="onViewJob.emit($event)"
       (onContextMenu)="onContextMenu.emit($event)"
       (onReverseJobSplit)="onReverseJobSplit.emit($event)">
  </app-planning-draft-jobs-table-list-row>
</div>
